<div class="progress mb-3" style="height: 5px;">
    <div class="progress-bar" role="progressbar" [style.width.%]="progressValue"></div>
    <div class="remaining-progress-bar" role="progressbar" [style.width.%]="100 - progressValue"></div>
</div>